import React, { useEffect } from 'react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { session } from '../../../services/session';

import { setAccountLink } from '../../../redux/actions';
import { paymentsService } from './payments-service';

import GeneralSettings from './general-settings';
import Payments from './payments';
import DeveloperOptions from './developer-options';
import Icon from '../../ui/icon';

import './account-settings.scss';

const AccountSettings = ({ flags, match }) => {
  const accountLink = useSelector(state => state.accountLink) || {};
  const dispatch = useDispatch();

  useEffect(() => {
    if (match.params.publisherId && paymentsService.checkIfBillingUser() && flags.billingFeatures) {
      getAccountLink();
    }
  }, []);

  async function getAccountLink() {
    const res = await paymentsService.getAccountLink(match.params.publisherId);
    dispatch(setAccountLink(res.data.data[0]));
  }

  const sideBarTabs = [
    {
      label: 'General Settings',
      path: 'general-settings',
      iconName: 'gear',
      component: <GeneralSettings />,
    },
    {
      label: 'Developer Options',
      path: 'developer-options',
      iconName: 'wrench',
      component: <DeveloperOptions />,
    },
  ];

  const billingTab = {
    label: 'Payments',
    path: 'payments',
    iconName: 'creditCard',
    component: <Payments match={match} />,
  };

  if (paymentsService.checkIfBillingUser() && flags.billingFeatures && !flags.paymentsNavitem) {
    sideBarTabs.splice(1, 0, billingTab);
  }

  const activeTab = sideBarTabs.find(option => match.params.activeTab === option.path);

  const sidebar = sideBarTabs.map((option, index) => {
    const path = option.path !== 'payments' ? option.path : `${option.path}/payment-setup`;

    const alertIcon =
      paymentsService.showAlertIcon(accountLink) && option === billingTab ? (
        <Icon iconName="filledAlert" size={16} />
      ) : null;

    const orgType = session.userRole === 'merchants' ? 'merchant' : 'publisher';

    return (
      <div key={index}>
        <Link to={`/v2/${orgType}/${session.orgId}/account-settings/${path}`}>
          <Icon iconName={option.iconName} size={12} />
          <div className={`label ${option === activeTab ? 'active' : ''}`}>{option.label}</div>
          {alertIcon}
        </Link>
      </div>
    );
  });

  const horizontalLine = match.params.activeTab !== 'payments' ? <hr></hr> : null;

  return (
    <div className="account-settings-container fs-mask">
      <h1>Account Settings</h1>
      <div className="content">
        <div className="account-settings-sidebar">{sidebar}</div>
        <div className="account-settings">
          <h2>{activeTab.label}</h2>
          {horizontalLine}
          <div>{activeTab.component}</div>
        </div>
      </div>
    </div>
  );
};

export default withLDConsumer()(AccountSettings);
